import React, { useRef } from 'react';
import { Modal, Typography } from 'antd';
import CloseIcon from '@mui/icons-material/Close';
import ModifyCatalogStepper from '../ModifyCatalogStepper';

const EditPublishedCatalogModal = ({
    modalState,
    setModalState,
    fetchCatalogues,
    messageApi,
    stepperKey,
    currentStep,
    setCurrentStep,
    draftFormData,
    currentPublishedCatalogueId,
    onFormInstanceReady,
    isUpdatingExistingDraft = false,
    existingDraftId = null
}) => {
    // Reference to store the form instance from ModifyCatalogStepper
    const formInstanceRef = useRef(null);

    // Funzione per gestire la richiesta di chiusura
    const handleCloseRequest = () => {
        setModalState('closePublishedConfirm');
    };

    return (
        <>
            <Modal
                title={
                    <Typography.Title level={4} style={{ marginBottom: '1rem' }}>
                        Modify Published Catalogue
                    </Typography.Title>
                }
                open={modalState === 'modifyPublished'}
                onCancel={handleCloseRequest}
                width="85vw"
                centered
                maskClosable={false}
                footer={null}
                destroyOnHidden={true}
                closeIcon={
                    <div
                        className="modal-close-button"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '40px',
                            height: '40px',
                            borderRadius: '6px',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                            backgroundColor: 'transparent',
                            padding: '8px',
                        }}
                        onClick={handleCloseRequest}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#f5f5f5';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                    >
                        <CloseIcon
                            style={{
                                fontSize: '24px',
                                color: '#666',
                                margin: 0,
                                pointerEvents: 'none'
                            }}
                        />
                    </div>
                }
            >
                <ModifyCatalogStepper
                    key={stepperKey}
                    onCancel={handleCloseRequest}
                    onFinish={() => {
                        // Il salvataggio viene gestito direttamente in ModifyCatalogStepper
                        // tramite il servizio savePublishedCatalogAsDraft
                        setModalState('closed');
                        fetchCatalogues(true); // Force refresh after modifying
                    }}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    initialFormData={draftFormData}
                    originalCatalogueId={currentPublishedCatalogueId}
                    isDomainInputDisabled={true}
                    isUpdatingExistingDraft={isUpdatingExistingDraft}
                    existingDraftId={existingDraftId}
                    onFormInstanceReady={(formInstance) => {
                        // Store the form instance in the ref
                        formInstanceRef.current = formInstance;
                        // Pass it to parent if callback exists
                        if (onFormInstanceReady) {
                            onFormInstanceReady(formInstance);
                        }
                    }}
                />
            </Modal>
        </>
    )
}

export default EditPublishedCatalogModal;
